module.exports = __webpack_public_path__ + "static/media/kayako.87a5c496.svg";